import {useFormContext} from 'react-hook-form';
import {Checkbox} from '@common-web/components/ui/checkbox';
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@common-web/components/ui/form';

export function CheckboxField({
  name,
  label,
  className,
}: {
  name: string;
  label: string;
  className?: string;
}) {
  const {control} = useFormContext();
  return (
    <FormField
      control={control}
      name={name}
      render={({field}) => (
        <FormItem className={className}>
          <label className='flex cursor-pointer items-start gap-3 rounded-lg border border-neutral-200 bg-neutral-50 p-3 text-xs leading-relaxed text-neutral-600'>
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={(value) => field.onChange(value === true)}
                className='mt-0.5'
              />
            </FormControl>
            <span>{label}</span>
          </label>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
